export interface SelectedProcedureInterfaceState {
  code?: string;
}

export const initialSelectedProcedureState: SelectedProcedureInterfaceState = {
  code: null
};
